/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:27
 * @LastEditTime: 2020-07-13 19:13:07
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\planningResource\planningResourceRouter.js
 * @Description: 
 */ 
/**
 * 描述：策划资源路由
 * 日期：2017-11-6
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('planningResourceRouterModule', [])
    . config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.planningresource', {
            url: '/planningresource',
            views: {
                'main@front': {
                    templateUrl: './planningResource/main_tpl.html',
                },
                'left@front.planningresource': {
                    templateUrl: './planningResource/left/left_tpl.html',
                    controller: 'planningResourceLeftCtrl'
                },
                'footer@front.planningresource': {
                    templateUrl: './footer_tpl.html'
                }
            }
        });
    }]);
